import React from 'react';
import { PlacingWithCaptainVice } from '../../types/types';
import { PlacingsWithCaptainsCols, BuildPlacingsRows } from '../../globals/TableFunctions';
import { GridColDef, GridCellParams, GridRowParams, GridEvents, MuiEvent, GridCallbackDetails, GridRenderCellParams } from '@mui/x-data-grid';
import TableContainer from './TableContainer';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';
import { useNavigate } from 'react-router-dom';


export interface Props {
    placings: PlacingWithCaptainVice[];
    tooltipText?: string;
}

function PlacingsTable2({placings,tooltipText=""}:Props) {
    const router = useNavigate();
    const placingsRows = BuildPlacingsRows(placings);
    
    
    const onCellClick = (params: GridCellParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
        router(`/scteam/${params.row.theid}`);
    }

    return <TableContainer header="Top SC Teams" tooltipText={tooltipText}>
        <PlayerDataGrid
            height={500}
            rows={placingsRows}
            columns={PlacingsWithCaptainsCols}
            onCellClick={onCellClick}
            rowHeight={100}
        />
    </TableContainer>
}

export default PlacingsTable2;